import {
  DEPLOYMENT_URLS,
  STEP_SLUG,
} from '@/config/navigation.config'
import {
  IS_DEMO_DEPLOYMENT,
  IS_MAIN_DEPLOYMENT,
  IS_PLAYGROUND_DEPLOYMENT,
  IS_PREVIEW_ENV,
  IS_PROD_PLAYGROUND_DEPLOYMENT,
  IS_PRODUCTION_DEPLOYMENT,
  IS_STAGING_DEPLOYMENT,
  LOCAL_BASE_URL,
  VERCEL_URL,
} from '@/config/environments.config'

/**
 * Get site origin url depending on which branch or env we are in
 */
export const getSiteOriginForDeployment = (): string => {
// Define environment-to-URL mappings in priority order
  const environmentMappings = [
    { isActive: IS_MAIN_DEPLOYMENT, url: DEPLOYMENT_URLS.preProd },
    { isActive: IS_STAGING_DEPLOYMENT, url: DEPLOYMENT_URLS.staging },
    { isActive: IS_PLAYGROUND_DEPLOYMENT, url: DEPLOYMENT_URLS.playground },
    { isActive: IS_PROD_PLAYGROUND_DEPLOYMENT, url: DEPLOYMENT_URLS.prodPlayground },
    { isActive: IS_PRODUCTION_DEPLOYMENT, url: DEPLOYMENT_URLS.prod },
    { isActive: IS_DEMO_DEPLOYMENT, url: DEPLOYMENT_URLS.demo },
  ]

  // Find the first matching environment
  const matchingEnvironment = environmentMappings.find((env) => env.isActive)

  // Return the URL for the matching environment, or empty string if none match
  return matchingEnvironment?.url || ''
}

/**
 * Returns the appropriate Auth0 base URL based on the current environment
 * Priority: custom origin → preview URL → development/local URL
 */
export const getSiteOrigin = (): string => {
  // First priority: use site URL origin if available
  const origin = getSiteOriginForDeployment()

  if (origin) {
    return origin
  }

  // Second priority: use Vercel URL for preview environments
  if (IS_PREVIEW_ENV) {
    return `https://${VERCEL_URL}`
  }

  // Last priority: use local development URL
  return LOCAL_BASE_URL || 'http://localhost:3000'
}

/**
 * Is the current page the confirmation page
 * @param {string} path
 * @returns {boolean}
 */
export const isConfirmationPage = (path: string): boolean => path.includes(`/${STEP_SLUG.Confirmation}/`)

